import {BaseModel} from "../base.model";

export interface Activity extends BaseModel {

}

export const defaultActivity: Readonly<Activity> = {};